<template>
    <div class="d-flex search-bar__wrapper">
        <div v-if="pageName === 'index'" class="search-bar__block search-bar__block--first">
            <i
                v-if="query !== ''"
                class="fal fa-times"
                :class="{
                    'search-bar__close--index': pageName === 'index',
                    'search-bar__close': pageName !== 'index'
                }"
                @click="removeSearch"
            ></i>
        </div>
        <div v-else class="search-bar__block search-bar__block--first"
            @click="closeSearch"
        >
            <i
                class="fal fa-times"
                :class="{
                    'search-bar__close--index': pageName === 'index',
                    'search-bar__close': pageName !== 'index'
                }"
            ></i>
        </div>
        <div class="search-bar__block search-bar__block--middle">
            <div class="brekz-header-main__search-wrapper">
                <AutoComplete :is-mobile="true" />
                <span class="search-bar__button--mobile hidden-lg-up"></span>
            </div>
        </div>
        <div
            class="search-bar__block search-bar__block--last"
            @click="hitSearch"
        >
            <span class="search-bar__button--mobile">
                <i class="fal fa-search" aria-hidden="true"></i>
            </span>
        </div>

    </div>
</template>

<script>
import { debounce } from "lodash-es";
import AutoComplete from "./Autocomplete/AutoComplete.vue";

const hideMobileKeyboardOnReturn = (element) => {
    element.addEventListener('keyup', (keyboardEvent) => {
        const key = keyboardEvent.code || keyboardEvent.keyCode;
        if (key === 'Enter' || key === 13) {
            element.blur();
        }
    });
};

export default {
    name: "AlgoliaSearchInputMobile",
    components: { AutoComplete },
    props: {
        device: {
            required: false,
            default: false,
            type: String
        },
        pageName: {
            type: [String, Number],
            required: false
        },
    },
    data() {
        return {
            query: ""
        };
    },
    mounted() {
        const searchParams = new URLSearchParams(window.location.search);

        window.EventBus.$on('search-input-hit', (query) => {
            this.query = query;
        });

        if (searchParams.has("query")) {
            this.query = searchParams.get("query");
            $('.search-bar--mobile').css("display", "block");

            if($('#navbarSupportedContent').hasClass('show')){
                $('.button--menu-toggle').click();
            }

            $('.header-whitespace').toggleClass('header-whitespace--search-active');
            $('.search-bar--mobile .search-bar__input').focus();

            $(".js-search-icon").removeClass("d-block");
            $(".js-search-icon").addClass("d-none");
            $(".search-bar").removeClass("d-none");
            $(".search-bar").addClass("d-block");
        }

        window.document.querySelectorAll('[type=search]').forEach((element) => {
            hideMobileKeyboardOnReturn(element);
        });
    },
    methods: {
        hitSearch() {
            const autoCompleteSearchButton = document.querySelectorAll('.aa-DetachedSearchButton')[1];

            if (autoCompleteSearchButton) {
                autoCompleteSearchButton.click();
            }
        },
        removeSearch() {
            this.query = "";
            const urlClass = new URL(document.location);
            urlClass.searchParams.delete("query");

            const urlWithoutQuery = urlClass.toString();
            const urlWithQuery = urlClass.toString();

            if (history.pushState) {
                window.history.pushState({ path: urlWithoutQuery }, "", urlWithQuery);
            }

            EventBus.$emit("search-input-hit", "");
            EventBus.$emit("set-mobile-search-input", "");

            window.scrollTo({
                top: 1,
                behavior: 'smooth',
            });
        },
        closeSearch() {
            this.removeSearch();

            $('.search-bar--mobile').not(document.getElementsByClassName('search-bar--mobile--index')[0]).css("display", "block");

            if($('#navbarSupportedContent').hasClass('hide')){
                $('.button--menu-toggle').click();
            }

            $('.header-whitespace').toggleClass('header-whitespace--search-active');
            $('.search-bar--mobile .search-bar__input').focus();

            $(".js-search-icon").removeClass("d-none");
            $(".js-search-icon").addClass("d-block");
            $(".search-bar").not(document.getElementsByClassName('search-bar--mobile--index')[0]).removeClass("d-block");
            $(".search-bar").not(document.getElementsByClassName('search-bar--mobile--index')[0]).addClass("d-none");
        }
    }
};
</script>
